module.exports = __webpack_public_path__ + "img/nav2.a152e2af.jpg";